module.exports = __webpack_public_path__ + "img/read_menu_pay_tit.f809a8b4.png";